// XML-Entities in Werten externalisierter Parameter.
//
// Derselbe Wert kommt je Tenant unterschiedlich geschrieben an, etwa `https://&lt;tenant&gt;` und `https://<tenant>`
// (Live-Fall 29.10.2026). Die Integration Suite maskiert Werte, die in der Oberfläche oder über SAPs eigene
// Parameter-Action gepflegt werden; ein roher API-PUT speichert sie unmaskiert. Für den Vergleich zählt deshalb nur die
// entschlüsselte Form. Der Wert selbst bleibt unverändert, weil seine Schreibweise beim Schreiben an den Tenant zählt.

const ENTITY = /&(?:(lt|gt|amp|quot|apos)|#(\d{1,7})|#x([0-9a-fA-F]{1,6}));/g;
const NAMED = { lt: "<", gt: ">", amp: "&", quot: "\"", apos: "'" };

/**
 * Entschlüsselt die fünf XML-Entities und numerische Zeichenreferenzen genau einmal, in einem Durchgang.
 * `&amp;lt;` wird zu `&lt;`, nicht zu `<`. Ungültige Codepunkte bleiben unverändert stehen.
 * @param {*} value
 * @returns {string}
 */
export function decodeXmlEntities(value) {
  if (value === null || value === undefined) return "";
  const text = String(value);
  if (!text.includes("&")) return text;
  return text.replace(ENTITY, (match, name, dec, hex) => {
    if (name) return NAMED[name];
    const code = dec !== undefined ? parseInt(dec, 10) : parseInt(hex, 16);
    if (!(code > 0 && code <= 0x10ffff) || (code >= 0xd800 && code <= 0xdfff)) return match;
    return String.fromCodePoint(code);
  });
}

/**
 * Ob zwei Parameterwerte dieselbe Angabe sind, nur unterschiedlich maskiert. Leer, null und undefined gelten als gleich.
 * @param {*} a
 * @param {*} b
 * @returns {boolean}
 */
export function sameParameterValue(a, b) {
  return decodeXmlEntities(a) === decodeXmlEntities(b);
}
